import axios from "axios"

export function getSerialNumberActivityLog (sn) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/inventory/product/stock-activity/${sn}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};